import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function CTAFinal() {
  const contactDetails = [{
    label: '🕐 Respuesta',
    value: 'Inmediata'
  }, {
    label: '🔒 Confidencialidad',
    value: 'Absoluta'
  }, {
    label: '💬 Costo de Evaluación',
    value: 'Sin costo'
  }, {
    label: '🌎 Cobertura',
    value: 'Todo Estados Unidos'
  }];
  return <section className="w-full bg-white py-16 px-4 border-b border-gray-200" data-id="element-10">
      <div className="max-w-4xl mx-auto space-y-10" data-id="element-11">
        <div className="space-y-4 text-center" data-id="element-12">
          <h2 className="text-sm font-bold tracking-widest uppercase text-navy-900 border-b-2 border-gold-500 pb-2 inline-block" data-id="element-13">
            SECCIÓN 9
          </h2>
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 leading-tight" data-id="element-14">
            SOLICITA TU EVALUACIÓN INICIAL — SIN COSTO
          </h3>
          <p className="text-lg md:text-xl text-gray-700 font-serif leading-relaxed max-w-2xl mx-auto mt-4" data-id="element-15">
            Después de meses de investigación, entrevistas y verificación de
            resultados, este es el único templo que nuestro equipo puede
            recomendar con total confianza. Si estás pasando por una situación
            difícil — emocional, espiritual o personal — te sugerimos que al
            menos solicites una evaluación inicial.{' '}
            <span className="font-bold text-navy-900" data-id="element-16">
              Es completamente gratuita, confidencial y sin compromiso.
            </span>{' '}
            No tienes nada que perder — y según lo que hemos documentado,
            podrías ganar mucho más de lo que imaginas.
          </p>
        </div>

        <div className="bg-gray-50 border border-gray-300 shadow-sm overflow-hidden" data-id="element-17">
          <table className="w-full text-left border-collapse" data-id="element-18">
            <tbody data-id="element-19">
              {contactDetails.map((row, index) => <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-20">
                  <td className="p-4 border-b border-gray-200 text-navy-900 font-bold w-1/3 md:w-1/4" data-id="element-21">
                    {row.label}
                  </td>
                  <td className="p-4 border-b border-gray-200 text-gray-800 font-serif" data-id="element-22">
                    {row.value}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center space-y-6 pt-8" data-id="element-23">
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-24">
            <a href="https://wa.me/13052196902" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-25">
              <Button size="large" leftIcon={<MessageCircle className="w-5 h-5" data-id="element-27" />} className="w-full bg-green-600 hover:bg-green-700 text-white border-none font-bold text-lg px-8 py-5 transition-colors" data-id="element-26">
                ESCRIBIR POR WHATSAPP
              </Button>
            </a>
            <a href="tel:+13053811985" className="w-full sm:w-auto" data-id="element-28">
              <Button size="large" leftIcon={<Phone className="w-5 h-5" data-id="element-30" />} className="w-full bg-blue-600 hover:bg-blue-700 text-white border-none font-bold text-lg px-8 py-5 transition-colors" data-id="element-29">
                LLAMAR AHORA
              </Button>
            </a>
          </div>
          <p className="text-sm md:text-base text-gray-500 font-serif italic" data-id="element-31">
            Privada. Confidencial. Sin presión. Sin juicios.
          </p>
        </div>
      </div>
    </section>;
}